<template>
  <div class="mod-calendar clearfix">
    <div class="arrow arrow-l" @click="prev">
      <l8-icon type="icon-zuoyoujiantou"></l8-icon>
    </div>
    <div class="arrow arrow-r" @click="next">
      <l8-icon type="icon-zuoyoujiantou2"></l8-icon>
    </div>
    <div class="wrapper">
      <a-spin v-if="loading"></a-spin>
      <ul v-else>
        <li v-for="(item, idx) in departureDates" :key="item.date" :class="{'active': current === idx}" @click="go(idx)">
          <div>{{ item.date | format('MM月DD日') }}</div>
          <div>{{ item.date | format('dddd') }}</div>
          <div class="price">{{ item.price | price }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { fetchFareTrend } from '@/apis/flight'
import _ from 'lodash'
import moment from 'moment'
import '../css/calendar.less'
const now = new Date().getTime()
const weekTime = 7 * 24 * 3600 * 1000

export default {
  props: {
    departureDate: String,
    segment: Object
  },
  data () {
    return {
      departureDates: [],
      loading: false
    }
  },
  computed: {
    current: function () {
      return _.findIndex(this.departureDates, { date: this.departureDate })
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    async fetch () {
      this.loading = true
      const { segment, departureDate } = this

      const params = {
        airlineCode: segment.airlineCode,
        depCode: segment.departureCode,
        arrCode: segment.arrivalCode,
        date: departureDate,
        day: 7
      }
      fetchFareTrend(params).then(data => {
        this.loading = false
        this.departureDates = data || []
      }).catch(err => {
        this.loading = false
        this.$message.error(err.message || '网络异常，请稍后再试！')
      })
    },
    prev () {
      let date = new Date(this.departureDate).getTime() - weekTime

      if (date < now) {
        date = now

        if (moment(now).format('YYYY-MM-DD') === this.departureDate) {
          this.$alert('不能切换星期，请注意各航段之间的时间差')
          return
        }
      }

      this.$emit('change', moment(date).format('YYYY-MM-DD'))
    },
    next () {
      const date = new Date(this.departureDate).getTime() + weekTime
      this.$emit('change', moment(date).format('YYYY-MM-DD'))
    },
    go (idx) {
      this.$emit('change', this.departureDates[idx].date)
    }
  },
  filters: {
    price: function (value) {
      if (!value) {
        return '-'
      }

      return `${value}元`
    },
    format: (value, format) => {
      if (!value) {
        return '-'
      }

      return moment(value).format(format)
    }
  }
}
</script>
